import { render } from "./Supervision.vue?vue&type=template&id=1989d6a1&scoped=true"
import script from "./Supervision.vue?vue&type=script&lang=js"
export * from "./Supervision.vue?vue&type=script&lang=js"

import "./Supervision.vue?vue&type=style&index=0&id=1989d6a1&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1989d6a1"]])

export default __exports__